/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { getStoreCompanies, getStoreEmployees } from "../../../store/actions";
// component
import PersonTreeTable from "../../../components/PersonTreeTable";
import Grade from "../../Manager/CompanyInfo/GradesManagement/Grade";
// utils
import { get, isEmpty, findIndex, forEach } from "lodash";
import { sortByKey } from "../../../utils/sort";
import { toast } from "../../../utils/toast";
// apis
import {
  createGradesOrganize,
  deleteGrades,
} from "../../../apis/companies/grade";
import { updateEmployeeInGrades } from "../../../apis/employee/employee";
// Icon
import AddPersonIcon from "../../../assets/images/person/add-person-icon.svg";
import PencilIcon from "../../../assets/images/person/pencil-icon.svg";
import ArrowTopIcon from "../../../assets/images/person/arrow-top-icon.svg";
import ArrowBottomIcon from "../../../assets/images/person/arrow-bottom-icon.svg";
import TrashIcon from "../../../assets/images/person/trash-icon.svg";
import PersonIcon from "../../../assets/images/icon/custom-tree/person-icon.svg";
// import systemAlert from "../../../utils/systemAlert";
import { searchEmployee } from "../../../utils/employee";
// import InformaitonIcon from "../../../assets/images/person/i-icon.svg";

const GradesView = ({ type = "grade", mode, isTax = false }) => {
  const dispatch = useDispatch();
  const { storeEmployees, storeManagerEmployees, storeGrades, storeManagerGrades } = useSelector(
    (store) => ({
      storeEmployees: store.Data.employees,
      storeManagerEmployees: store.Data.managerEmployees,
      storeGrades: store.Data.grades,
      storeManagerGrades: store.Data.managerGrades,
    }),
    shallowEqual
  );

  const [treeData, setTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    name: "",
    employees: [],
  });
  const [defaultSelected, setDefaultSelected] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [isFirst, setIsFirst] = useState(true);
  // 상세
  const [gradeOpen, setGradeOpen] = useState(false);
  const [gradeData, setGradeData] = useState({});
  const [formMode, setFormMode] = useState("create");
  // 직원 등록
  const [targetEmployee, setTargetEmployee] = useState([]);

  const [grades, setGrades] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    setGrades(isTax ? storeManagerGrades : storeGrades);
    setEmployees(isTax ? storeManagerEmployees : storeEmployees);
  }, [isTax, storeGrades, storeManagerGrades, storeEmployees, storeManagerEmployees]);

  useEffect(() => {
    submit();
  }, [employees, grades]);

  // 트리 데이터 생성
  const submit = () => {
    setIsLoading(true);
    let treeData = [];

    if (!isEmpty(grades)) {
      sortByKey(grades, "sort");
      treeData = [
        ...grades.map((grade) => ({
          title: grade.name,
          key: grade.idx,
          sort: grade.sort,
          code: grade.code,
          icon: PersonIcon
        })),
        { title: "미지정", key: "unspecified" },
      ];
    } else {
      treeData = [{ title: "미지정", key: "unspecified" }];
    }
    setIsLoading(false);
    setTreeData(treeData);

    if (isFirst) {
      setSelectedData(treeData[0] || {});
      setTableData({
        name: get(treeData, "[0].title"),
        employees: employees.filter(
          (employee) => employee.idx === get(grades, "[0].idx")
        ),
      });
      setDefaultSelected([get(treeData, "[0].key")]);
    }
    setIsFirst(false);
    setSelectedData((oldVal) =>
      treeData.find((data) => get(data, "key") === get(oldVal, "key"))
    );
  };

  useEffect(() => {
    if (get(selectedData, "key") !== "unspecified") {
      submitTableData();
    }
  }, [selectedData]);

  const submitTableData = () => {
    setTableData({
      name: get(selectedData, "title"),
      employees: employees.filter(
        (employee) => employee.gradeIdx === get(selectedData, "key")
      ),
    });
  };

  // 선택 액션
  const onSelect = (keys, evenvt) => {
    const { node, selected } = evenvt;

    if (selected) {
      setSelectedData(node);
      if (node.key === "unspecified") {
        setTableData({
          name: node.title,
          employees: employees.filter((employee) => !employee.gradeIdx),
        });
      } else {
        setTableData({
          name: node.title,
          employees: employees.filter(
            (employee) => employee.gradeIdx === node.key
          ),
        });
      }
    } else {
      setSelectedData({});
      setTableData({});
    }
  };

  // 직급 추가
  const handleAddAction = () => {
    if (!isEmpty(grades)) {
      if (isEmpty(selectedData)) {
        return toast.error("등록할 직급의 상위 직급을 선택해주세요.");
      }
      if (selectedData.key === "unspecified") {
        return toast.error("미지정 하위에 직급을 생성할 수 없습니다.");
      }
      setGradeOpen(true);
      setFormMode("create");
    } else {
      setGradeOpen(true);
      setFormMode("create");
    }
  };

  // 직급 수정
  const handleEditAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 직급이 없습니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 직급은 수정할 수 없습니다.");
    }
    setGradeOpen(true);
    setFormMode("update");
    setGradeData(selectedData);
  };

  // 직급 삭제
  const handleDeleteAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 직급이 없습니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 직급은 삭제할 수 없습니다.");
    }
    const _treeData = treeData;
    const changeData = _treeData.filter(
      (data) => data.sort > selectedData.sort
    );
    const orgData = {
      grades: changeData.map((grade) => ({
        gradeIdx: grade.key,
        sort: grade.sort - 1,
      })),
      isTax
    };

    const deleteForm = {
      isTax,
    };

    deleteGrades(get(selectedData, "key"), deleteForm).then(() => {
      createGradesOrganize(orgData).then(() => {
        dispatch(getStoreCompanies());
      });
    });
  };

  // 직급 위로
  const handleTopAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 직급이 없습니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 직급은 수정할 수 없습니다.");
    }
    const oldIndex = findIndex(treeData, (d) => d.key === selectedData.key);
    const newIndex = oldIndex - 1;
    if (oldIndex === 0) return;
    setTreeData([...moveArrayItemToNewIndex(treeData, oldIndex, newIndex)]);
    reOrganizeGrades();
  };

  // 아래로
  const handleBottomAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 직급이 없습니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 직급은 수정할 수 없습니다.");
    }
    const oldIndex = findIndex(treeData, (d) => d.key === selectedData.key);
    const newIndex = oldIndex + 1;
    const lastIndex = treeData.length - 2;
    if (oldIndex === lastIndex) return;
    setTreeData([...moveArrayItemToNewIndex(treeData, oldIndex, newIndex)]);
    reOrganizeGrades();
  };

  // 직급 개편하기
  const reOrganizeGrades = () => {
    const grades = treeData.filter((tree) => tree.key !== "unspecified");

    const form = {
      grades: grades.map((grade, idx) => ({
        gradeIdx: grade.key,
        sort: idx,
      })),
      isTax
    };

    createGradesOrganize(form)
      .then(() => {
        dispatch(getStoreCompanies());
      })
      .catch(() => { });
  };

  // 인덱스 변경
  const moveArrayItemToNewIndex = (arr, old_index, new_index) => {
    let orginArr = arr;
    if (new_index >= orginArr.length) {
      let k = new_index - orginArr.length + 1;
      while (k--) {
        orginArr.push(undefined);
      }
    }
    orginArr.splice(new_index, 0, orginArr.splice(old_index, 1)[0]);
    return orginArr;
  };

  const IconButtons = [
    { icon: AddPersonIcon, action: handleAddAction },
    { icon: PencilIcon, action: handleEditAction },
    { icon: ArrowTopIcon, action: handleTopAction },
    { icon: ArrowBottomIcon, action: handleBottomAction },
    { icon: TrashIcon, action: handleDeleteAction },
  ];

  const handleDeleteEmployee = (data) => {
    updateEmployeeInGrades(data.idx, { gradeIdx: null, isTax }).then(() => {
      dispatch(getStoreCompanies());
      dispatch(getStoreEmployees());
      setTargetEmployee([]);
    });
  };

  const handleAddEmployee = () => {
    searchEmployee(
      (employees) => {
        setTargetEmployee(employees);
      },
      targetEmployee,
      { isTax },
    );
  };

  useEffect(() => {
    if (!isEmpty(targetEmployee) && !isEmpty(selectedData)) {
      const promiseList = [];
      forEach(targetEmployee, employee => {
        promiseList.push(updateEmployeeInGrades(employee.idx, {
          gradeIdx: selectedData.key,
          isTax
        }));
      });

      Promise.all(promiseList)
        .then(() => {
          dispatch(getStoreCompanies());
          dispatch(getStoreEmployees());
          setTargetEmployee([]);
        });
    }
  }, [targetEmployee, selectedData]);

  return (
    <>
      <PersonTreeTable
        type={type}
        mode={mode}
        submit={submit}
        isLoading={isLoading}
        treeData={treeData}
        setTreeData={setTreeData}
        tableData={tableData}
        onSelect={onSelect}
        defaultSelectedKeys={defaultSelected}
        selectedData={selectedData}
        buttons={IconButtons}
        handleAddEmployee={handleAddEmployee}
        handleDeleteEmployee={handleDeleteEmployee}
      />
      <Grade
        open={gradeOpen}
        setOpen={setGradeOpen}
        list={gradeData}
        mode={formMode}
        treeData={treeData}
        preSort={get(selectedData, "sort")}
        isTax={isTax}
      />
    </>
  );
};

export default GradesView;
